import PuntoVenta from './PuntoVenta';
export default PuntoVenta;